import { useEffect, useRef, useState } from 'react';

export default function CountUp({
  value,
  duration = 900,
  format,
}: {
  value: number;
  duration?: number;
  format?: (n: number) => string;
}) {
  const [n, setN] = useState(0);
  const fromRef = useRef(0);
  const startRef = useRef(0);
  useEffect(() => {
    const from = fromRef.current;
    const to = value;
    const t0 = performance.now();
    startRef.current = t0;
    let raf = 0;
    const step = (t: number) => {
      const p = Math.min(1, (t - t0) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      const cur = from + (to - from) * eased;
      setN(cur);
      if (p < 1) raf = requestAnimationFrame(step);
      else fromRef.current = to;
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [value, duration]);
  const rounded = Math.round(n * 10) / 10;
  return <span className="count-anim">{format ? format(rounded) : Math.round(n).toLocaleString('fr-CH')}</span>;
}
